import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@deporvillage/picture-component';
import ActionGroup from './ActionGroup.js';

import styles from './BundledProducts.module.scss';

const BundledProducts = ({ items, click, isAdded, id }) => (
    <div className={styles["bundled-products-component"]}>
        <div className={styles["bundled-products-row"]}>
            <div className={styles["bundled-images-block"]}>
                {
                    items.map(({ id, title, url, gallery_images: images }) =>
                        <React.Fragment key={ id }>
                        <div className={styles["bundled-product-image"]}>
                            <a href={ url } title={ title }>
                                <Picture src={ `product/${ images.images[images.default] }` } name={ title } lazy width={ 100 }/>
                            </a>
                        </div>
                        <span className={styles["bundled-product-plus"]}>+</span>
                        </React.Fragment>
                    )
                }
            </div>
            <div className={styles["bundled-content-block"]}>
                <ActionGroup items={ items } click={ click || null } isAdded={ isAdded } id={ id } />
            </div>
        </div>
    </div>
);

BundledProducts.propTypes = {
    click: PropTypes.func,
    isAdded: PropTypes.bool,
    id: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            checked: PropTypes.bool,
            title: PropTypes.string,
            url: PropTypes.string,
            gallery_images: PropTypes.shape({
                default: PropTypes.number,
                images: PropTypes.arrayOf(PropTypes.string),
            }),
            price: PropTypes.shape({
                pvp: PropTypes.number,
                price: PropTypes.number,
                currency_code: PropTypes.string,
            }),
            variants: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
                    title: PropTypes.string,
                    selected: PropTypes.string,
                    price: PropTypes.shape({
                        pvp: PropTypes.number,
                        price: PropTypes.number,
                        currency_code: PropTypes.string,
                    }),
                    items: PropTypes.arrayOf(
                        PropTypes.shape({
                            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
                            title: PropTypes.string,
                            selected: PropTypes.string,
                            price: PropTypes.shape({
                                pvp: PropTypes.number,
                                price: PropTypes.number,
                                currency_code: PropTypes.string,
                            }),
                        }),
                    ),
                }),
            ),
        }),
    ),
};

export default BundledProducts;
